
import {Vue, Component} from "vue-property-decorator";
import LanguageModel from '@/models/LanguageModel';
import * as flags from 'country-flag-icons/string/3x2';

// Language tag -> country code. Add more languages here as needed.
const LANGUAGE_TO_COUNTRY: { [lang: string]: string } = {
  en: 'GB',   // or 'US' / 'CA'
  fr: 'FR',   // or 'CA' for Québec
};

@Component
export default class LanguageDropdown extends Vue {

  get items(): LanguageModel[] {
    return this.$store.state.global.languages;
  }

  get menu() {
    return this.items.map(lang => ({
      text: lang.tag.toUpperCase(), // EN, FR
      value: lang.id
    }));
  }

  flagSvg(tag: string): string {
    const country = LANGUAGE_TO_COUNTRY[tag.toLowerCase()] || tag.toUpperCase();
    return (flags as unknown as { [code: string]: string })[country] || '';
  }

  onChanged(event: any): void {
    this.$store.commit("global/setLanguage", event);
  }
}
